// extracted by mini-css-extract-plugin
export default {"PrimaryCTA":"PrimaryCTA_PrimaryCTA__OXJ3F","XLarge":"PrimaryCTA_XLarge__gzSLz","Gold":"PrimaryCTA_Gold__VdoTt"};